import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { AngularEditorConfig } from '@kolkov/angular-editor';

interface archivo {
  nombre: string;
  size: number;
  url: string;
  type: string;
}

interface modulo {
  archivos: archivo[]
  descripcion: string,
  duracion: number,
  id: number,
  idVideo: number,
  numero: number,
  tipo: string,
  titulo: string,
  HTMLcontent: string,
  vigente: boolean,
}

interface moduloProgreso {
  archivos: archivo[]
  descripcion: string,
  duracion: number,
  id: number,
  idVideo: number,
  numero: number,
  tipo: string,
  titulo: string,
  HTMLcontent: string,
  vigente: boolean,
  completado: number,
}

@Component({
  selector: 'editar-curso-sesiones',
  templateUrl: './editar-curso-sesiones.component.html',
  styleUrls: ['./editar-curso-sesiones.component.css']
})
export class EditarCursoSesionesComponent implements OnInit {

  id = this.route.snapshot.paramMap.get('id');
  clases: modulo[] = [];
  duracion: number = 0;
  nuevoProgreso: moduloProgreso[] = [];

  // Variables para el popup del modulo
  closeResult: string;
  modulo: modulo;
  editar = 0;

  mostrarInfo: string = 'info';

  // Variables auxilires para guardar archivo

  downloadURL: any;
  fire: any;

  // configuracion de angular editor

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(
    public modalService: NgbModal,
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.cargarSesion();
  }

  cargarSesion() {
    this.afs.collection('sesiones').doc(this.id).ref.get().then(doc => {
      const sesion = doc.data();
      this.clases = sesion['clases'];
      this.duracion = sesion['duracion']
    }).catch(error => {
      console.log(error)
    })
  }

  // Metodos para editar los modulos
  anadirModulo(content) {
    this.editar = 0;
    this.modulo = {
      archivos: [],
      descripcion: '',
      duracion: 0,
      id: this.clases.length,
      idVideo: 0,
      numero: 0,
      tipo: 'video',
      titulo: '',
      HTMLcontent: '',
      vigente: true,
    }
    this.openPopUp(content);
  }

  eliminarModulo(id) {
    const idx = this.clases.findIndex(x => x.id == id)
    this.clases.splice(idx, 1)
  }

  editarModulo(id, content) {
    this.editar = 1
    const idx = this.clases.findIndex(x => x.id == id);
    this.modulo = this.clases[idx]
    this.openPopUp(content);
  }

  guardarModulo(id) {
    if (this.editar == 0) {
      this.clases = this.clases.concat(this.modulo)
    } else {
      const idx = this.clases.findIndex(x => x.id == id);
      this.clases[idx] = this.modulo
    }
    this.modalService.dismissAll("modulo guardado")
  }

  anadirArchivo(event) {
    const file = event.target.files[0];
    console.log(file.name)
    let nombre: string = file.name
    nombre = nombre.replace(' ','-');
    const filePath = `Sesiones/${this.id}/${nombre}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Sesiones/${this.id}/${nombre}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }
            const fileInfo = {
              nombre: nombre,
              size: file.size,
              url: url,
              type: file.type
            }
            this.modulo.archivos = this.modulo.archivos.concat(fileInfo)
          });
        })
      ).subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  cargarPDF(event) {
    var n = Date.now();
    const file = event.target.files[0];
    const filePath = `Sesiones/${this.id}/pdf:${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Sesiones//${this.id}/pdf:${n}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }
            this.modulo.HTMLcontent = url;
          });
        })
      ).subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  eliminarArchivo(archIndex) {
    this.modulo.archivos.splice(archIndex, 1);
  }

  // GUARDADO DE SESIONES

  guardarSesion() {
    // Calculo de duracion
    let duracion = 0;
    let versionVisitante: any[] = [];
    // Filtrado para version de visitante
    for (let index = 0; index < this.clases.length; index++) {
      const dur = this.clases[index].duracion;
      const aux = {
        id: this.clases[index].id,
        numero: this.clases[index].numero,
        descripcion: this.clases[index].descripcion,
        titulo: this.clases[index].titulo,
        duracion: this.clases[index].duracion,
        tipo: this.clases[index].tipo
      }
      duracion += dur;
      versionVisitante = versionVisitante.concat(aux)
    }
    this.afs.collection('sesiones').doc(this.id).update({ clases: this.clases, duracion: duracion })
      .then(() => {
        this.afs.collection('sesionesVisitante').doc(this.id).update({ clases: versionVisitante, duracion: duracion })
      })
      .then(() => {
        this.afs.collection('cursos').doc(this.id).update({ duracion: duracion })
      })
      .catch(error => console.log(error));
  }

  actualizarProgresos() {
    this.afs.collection('usuariosProgresos').ref.where('cursoId', '==', this.id).get().then(response => {
      response.docs.forEach((doc) => {
        const data = doc.data();
        const clases = data['clases'];
        for (let index = 0; index < this.clases.length; index++) {
          if (this.clases[index].vigente == true) {
            let completado = 0
            for (let indexViejo = 0; indexViejo < clases.length; indexViejo++) {
              if (this.clases[index].id == clases[indexViejo].id) {
                completado = clases[indexViejo].completado;
              };
            }
            const obj: moduloProgreso = {
              archivos: this.clases[index].archivos,
              descripcion:this.clases[index].descripcion ,
              duracion: this.clases[index].duracion,
              id: this.clases[index].id,
              idVideo: this.clases[index].idVideo,
              numero: this.clases[index].numero,
              tipo: this.clases[index].tipo,
              titulo: this.clases[index].titulo,
              HTMLcontent: this.clases[index].HTMLcontent,
              vigente:this.clases[index].vigente,
              completado: completado,
            }
            this.nuevoProgreso = this.nuevoProgreso.concat(obj)
          }
        }
        console.log(this.nuevoProgreso)
        const nuevoProgreso = this.nuevoProgreso;
        this.nuevoProgreso = []
        this.afs.collection('usuariosProgresos').doc(doc.id).update({
          clases: nuevoProgreso,
        }).then(() => {
          console.log('curso sincronizado')
        }).catch(error => {
          console.log(error)
        })
      })
    }).catch(error => {
      console.log(error)
    })
  }

  /// Metodos para el uso del pop up

  openPopUp(content) {
    this.mostrarInfo = 'info';
    this.modalService.open(content,{size: 'w300'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    });
  }

  async deleteArchivo(index) {
    const downloadUrl = this.modulo.archivos[index].url
    return this.storage.storage.refFromURL(downloadUrl).delete().then(() => {
      console.log(index)
      this.modulo.archivos.splice(index,1);
      return console.log('archivo eliminado')
    })
  }
}
